import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../header';
import { NavTabs } from '../nav';
import { LoadingView } from '../loading-view';
export const DashboardLayout = () => {
    return (_jsxs("section", { children: [_jsx(Header, {}), _jsx(NavTabs, {}), _jsx(Suspense, { fallback: _jsx(LoadingView, { height: "100%" }), children: _jsx(Outlet, {}) })] }));
};
